/**
 * Copyright © 2024 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */
import { gql } from '@apollo/client'

const SOVI_SHARE_FRAGMENT = gql`
  fragment SOVIShare on SOVIShare {
    facings
    numCases
    date
    groupId
  }
`

export const GET_SOVI_SHARE_INTERVAL_REPORT = gql`
  query GetSOVIShareInvervalReport($input: AdminDashboardIntervalReportInput!) {
    soviShareIntervalReport(input: $input) {
      ...SOVIShare
    }
  }
  ${SOVI_SHARE_FRAGMENT}
`
